var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Calendar"},[_c('BaseNavbar',{attrs:{"className":"Calendar-Nav","navItems":_vm.years},on:{"set-value":_vm.selectActiveYear}}),_c('CalendarTable',{attrs:{"year":+_vm.years[_vm.activeYear]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }